/**
 * Store registry — Dyrejournal-koden (A): veterinary/clinic domain stores.
 * Part of the product-composition layer: app.js merges the three registries
 * (core + dyrejournal + other) into this.stores. Key names must stay exactly
 * as components expect them via props.stores.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
import journalStore from '../stores/journal';
import phoneConsultationStore from '../stores/phoneConsultation';
import prescriptionOrderStore from '../stores/prescriptionOrder';
import prescriptionStore from '../stores/prescription';
import drugStore from '../stores/drug';
import animalStore from '../stores/animal';
import animalSpecieStore from '../stores/animalSpecie';
import animalBreedStore from '../stores/animalBreed';
import animalHealthRecordStore from '../stores/animalHealthRecord';
import visitorStore from '../stores/visitor';
import smsBulkStore from '../stores/smsBulk';
import diagnoseStore from '../stores/diagnose';
import insuranceCompanyStore from '../stores/insuranceCompany';
import idexxStore from '../stores/idexx';
import idexxAdminStore from '../stores/idexxAdmin';
import duettStore from '../stores/duett';
import moduleRecommendationStore from '../stores/moduleRecommendation';

export default {
    journalStore,
    phoneConsultationStore,
    prescriptionOrderStore,
    prescriptionStore,
    drugStore,
    animalStore,
    animalSpecieStore,
    animalBreedStore,
    animalHealthRecordStore,
    visitorStore,
    smsBulkStore,
    diagnoseStore,
    insuranceCompanyStore,
    idexxStore,
    idexxAdminStore,
    duettStore,
    moduleRecommendationStore,
};
